import {createRouter, createWebHistory} from 'vue-router'
import Home from '../views/Home.vue'
import {guardRoute} from "../api";

const routes = [
    {
        path: '/',
        redirect: '/login',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: '/dashboard',
        meta: { routeCode: 'dashboard'},
        name: 'Dashboard',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
    },
    {
        path: '/reports',
        meta: { routeCode: 'report'},
        name: 'Reports',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "reports" */ '../views/Reports.vue')
    },
    {
        path: '/report/view/:id?',
        meta: { routeCode: 'report'},
        name: 'ShowReport',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "showreport" */ '../../../core/views/ShowReport.vue')
    },
    {
        path: '/report/:id?',
        meta: { routeCode: 'report'},
        name: 'Report',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "report" */ '../views/Report.vue')
    },
    {
        path: '/emulsion-reports',
        meta: { routeCode: 'emulsion-reports'},
        name: 'EmulsionReports',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "emulsionreport" */ '../views/EmulsionReports.vue')
    },
    {
        path: '/emulsion/:id?/statement/:dateFrom?/:dateTo?',
        meta: { routeCode: 'emulsion-reports'},
        name: 'EmulsionStatement',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "emulsionstatement" */ '../views/EmulsionStatement.vue')
    },
    {
        path: '/totals',
        name: 'Totals',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "totals" */ '../views/Totals.vue')
    },
    {
        path: '/total/:id',
        name: 'Total',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "total" */ '../views/Total.vue')
    },
    {
        path: '/buildings',
        meta: { routeCode: 'buildings'},
        name: 'Buildings',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "buildings" */ '../views/Buildings.vue')
    },
    {
        path: '/investment/:id/statement/:dateFrom?/:dateTo?',
        meta: { routeCode: 'investment'},
        name: 'InvestmentStatement',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "statement" */ '../views/InvestmentStatement.vue')
    },
    {
        path: '/investment/:id/emulsion',
        meta: { routeCode: 'investment'},
        name: 'Emulsions',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "emulsion" */ '../views/Emulsions.vue')
    },
    {
        path: '/investment/:id?',
        meta: { routeCode: 'investment'},
        name: 'Investment',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "investment" */ '../views/Investment.vue')
    },
    {
        path: '/machines',
        meta: { routeCode: 'machines'},
        name: 'Machines',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "machines" */ '../views/Machines.vue')
    },
    {
        path: '/machine/:id?',
        meta: { routeCode: 'machine'},
        name: 'Machine',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "investment" */ '../views/Machine.vue')
    },
    {
        path: '/user/:id?',
        meta: { routeCode: 'user'},
        name: 'User',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "investment" */ '../views/User.vue')
    },
    {
        path: '/users',
        meta: { routeCode: 'users'},
        name: 'Users',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue')
    },
    {
        path: '/asphalts',
        meta: { routeCode: 'asphalts'},
        name: 'Asphalts',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "asphalts" */ '../views/Asphalts.vue')
    },
    {
        path: '/tanks',
        meta: { routeCode: 'tanks'},
        name: 'Tanks',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "tanks" */ '../views/Tanks.vue')
    },
    {
        path: '/tank/:id?',
        meta: { routeCode: 'tank'},
        name: 'Tank',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "tank" */ '../views/Tank.vue')
    },
    {
        path: '/states',
        meta: { routeCode: 'states'},
        name: 'States',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "states" */ '../views/States.vue')
    },
    {
        path: '/state/:id?',
        meta: { routeCode: 'state'},
        name: 'State',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "state" */ '../views/State.vue')
    },
    {
        path: '/state/view/:id?',
        meta: { routeCode: 'state'},
        name: 'ShowEmulsionReport',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "state" */ '../../../core/views/ShowEmulsionReport.vue')
    },
    {
        path: '/state/:id/statement/:dateFrom?/:dateTo?',
        meta: { routeCode: 'state'},
        name: 'StateStatement',
        beforeEnter: guardRoute,
        component: () => import(/* webpackChunkName: "statement" */ '../views/TankStatement.vue')
    },
    {
        path: '/403',
        name: 'Error403',
        beforeEnter: guardRoute,
        component: () => import('../views/Error403.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'Error404',
        beforeEnter: guardRoute,
        component: () => import('../views/Error404.vue')
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
